import styled, { css } from 'styled-components';
import { colorVariables } from 'theme/variables';

export const LinearProgressBarStyled = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: ${colorVariables.gray_smokegray};
  transform: translateX(-100%);
  will-change: transform;

  ${(props) =>
    props.progress &&
    css`
      transform: translateX(${-100 + props.progress}%);
      transition: all 0.7s ease-out;
    `};
`;
